import { useEffect, useRef, useState } from "react";
import { reportCRUD } from "../../../actions/report";
import moment from "moment";
import { char, number } from "../../../utils";
import { Button, DateRangePicker, Loader, SelectPicker } from "rsuite";
import FileExcelOIcon from "@rsuite/icons/legacy/FileExcelO";
import { useReactToPrint } from "react-to-print";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { selector } from "../../../api";
import { Input, message, Modal } from "antd";
import { configurationCRUD } from "../../../actions/configuration";
import { exportToExcel } from "../../../utils/exportExcel";

const { afterToday } = DateRangePicker;

export const StudentInvoiceData = () => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [fileName, setFileName] = useState("");
  const [data, setData] = useState([]);
  const [date, setDate] = useState([]);
  const [schools, setSchools] = useState([]);
  const [searchSchool, setSearchSchool] = useState("");
  const [schoolId, setSchoolId] = useState(null);
  const [regNumber, setRegNumber] = useState(null);
  const user = selector.User();

  const tableRef = useRef();
  const dataRef = useRef();

  useEffect(() => {
    setTimeout(() => {
      configurationCRUD
        .loadSchool(50, 0, searchSchool, "id")
        .then((resp) => {
          setSchools(resp.data.results);
        })
        .catch(() => {});
    }, 1000);
  }, [searchSchool]);

  const handleGeneratePdf = useReactToPrint({
    content: () => dataRef.current,
  });

  const handleExport = () => {
    if (!fileName) return;

    exportToExcel(data, fileName);
    setOpen(false);
  };

  const handleSearch = () => {
    if (!regNumber && !schoolId) {
      return message.error(
        "Please enter student registration number OR select a school",
      );
    }
    setLoading(true);
    const dataInvo = {
      reg_number: char.toUpperCase(regNumber),
      school_id: schoolId,
      start_date: date[0],
      end_date: date[1],
    };
    console.log(dataInvo);

    reportCRUD
      .loadStudentInvoiceDataReport(dataInvo)
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch(() => {
        setData([]);
        setLoading(false);
      });
  };

  return (
    <>
      <div className="row">
        <div className="col-12 card">
          <div className="card-body">
            <div className="row">
              <div className="col-md-2 col-sm-6">
                <Input
                  size="large"
                  placeholder="Student registration"
                  onChange={(e) => setRegNumber(e.target.value)}
                  value={regNumber}
                  allowClear
                />
              </div>
              <div className="col-md-2 col-sm-6">
                <SelectPicker
                  size="lg"
                  data={schools.map((school) => ({
                    value: school.id,
                    label: school.name,
                  }))}
                  block={true}
                  placeholder={"Select school"}
                  onSearch={(e) => setSearchSchool(e)}
                  onChange={(e) => setSchoolId(e)}
                  onClean={() => setSchoolId(null)}
                />
              </div>
              <div className="col-md-2 col-sm-6">
                <DateRangePicker
                  size="lg"
                  cleanable
                  placement="bottomEnd"
                  onClean={() => setDate([])}
                  onShortcutClick={(e) => {
                    setDate([
                      moment(e.value[0]).format("YYYY-MM-DD"),
                      moment(e.value[1]).add(1, "days").format("YYYY-MM-DD"),
                    ]);
                  }}
                  onOk={(e) =>
                    setDate([
                      moment(e[0]).format("YYYY-MM-DD"),
                      moment(e[1]).add(1, "days").format("YYYY-MM-DD"),
                    ])
                  }
                  shouldDisableDate={afterToday()}
                  placeholder="Select date range"
                  className="w-100"
                />
              </div>
              <div className="col-md-1">
                <Button
                  color="blue"
                  size="lg"
                  appearance="primary"
                  onClick={handleSearch}
                  block={true}
                >
                  <i className="bi bi-search" /> Search
                </Button>
              </div>
              <div className="col-md-2"></div>
              {data?.length ? (
                <>
                  <div className="col-md-2 col-sm-6">
                    <Button
                      size="lg"
                      color="green"
                      appearance="primary"
                      startIcon={<FileExcelOIcon />}
                      block={true}
                      disabled={!data.length}
                    >
                      {/* <DownloadTableExcel
                        filename="Report"
                        sheet="sheet1"
                        currentTableRef={tableRef.current}
                      >
                        Download Excel
                      </DownloadTableExcel> */}
                      <span onClick={() => setOpen(true)}>Export Excel</span>
                    </Button>
                  </div>
                </>
              ) : null}
            </div>
            <hr />
            <div className="row">
              <div className="col-12" ref={dataRef}>
                <div className="printHead">
                  <p className="text-center">
                    <img
                      width={100}
                      className="mt-0 mb-2"
                      src="assets/images/suza.jpeg"
                      alt=""
                    />
                  </p>
                  <p className="text-center fw-bold head1">
                    {char.toTitleCase("state university of Zanzibar")}
                  </p>
                  <p className="text-center mt-3 mb-3 head2">
                    {char.toUpperCase("student invoice report")}
                  </p>
                  <p className="text-start">
                    Periord :{" "}
                    <span className="fw-bold">
                      {date &&
                        moment(date[0]).format("DD MMM YYYY") +
                          " to " +
                          moment(date[1]).format("DD MMM YYYY")}
                    </span>
                  </p>
                  <p className="text-end">
                    Printed By :{" "}
                    <span className="fw-bold">
                      {char.toUpperCase(user.username)}
                    </span>
                  </p>
                  <p className="text-end mb-2">
                    Printed at :{" "}
                    <span className="fw-bold">
                      {moment().format("ddd DD MMM YYYY")}
                    </span>
                  </p>
                </div>
                <div className="table-responsive" ref={tableRef}>
                  <div className="repo-table">
                    <table className="table table-bordered table-sm">
                      <thead className="table-head">
                        <tr>
                          <th style={{ width: 50 }}>#</th>
                          <th>Registration</th>
                          <th>Full Name</th>
                          <th>Control #</th>
                          <th>Description</th>
                          <th>Invoice Date</th>
                          <th className="text-end">Invoice Amount</th>
                          <th className="text-end">Semister 1</th>
                          <th className="text-end">Semister 2</th>
                          <th>Payment Date</th>
                          <th>Paid Chennel</th>
                          <th>Reference ID</th>
                          <th>Transaction #</th>
                          <th className="text-end">Paid Amount</th>
                          <th className="text-end">Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((dt, i) => (
                          <tr>
                            <td style={{ width: 50 }}>{i + 1}</td>
                            <td>
                              {dt.reg_number
                                ? char.toUpperCase(dt.reg_number)
                                : "N/A"}
                            </td>
                            <td>
                              {dt.customer_name
                                ? char.toUpperCase(dt.customer_name)
                                : "N/A"}
                            </td>
                            <td>
                              {dt.invoice_no
                                ? char.toUpperCase(dt.invoice_no)
                                : "N/A"}
                            </td>
                            <td>
                              {dt.invoice_desc
                                ? char.toUpperCase(dt.invoice_desc)
                                : "N/A"}
                            </td>
                            <td>
                              {moment(dt.invoice_date).format("MMM DD, YYYY")}
                            </td>
                            <td>
                              {dt.invoice_amount
                                ? number.fNumberDoublePoint(dt.invoice_amount)
                                : "0.00"}
                            </td>
                            <td>
                              {dt.sem_1
                                ? number.fNumberDoublePoint(dt.sem_1)
                                : "0.00"}
                            </td>
                            <td>
                              {dt.sem_2
                                ? number.fNumberDoublePoint(dt.sem_2)
                                : "0.00"}
                            </td>
                            <td>
                              {moment(dt.date_paid).format("MMM DD, YYYY")}
                            </td>
                            <td>
                              {dt.channel
                                ? char.toUpperCase(dt.channel)
                                : "N/A"}
                            </td>
                            <td>
                              {dt.receipt_id
                                ? char.toUpperCase(dt.receipt_id)
                                : "N/A"}
                            </td>
                            <td>
                              {dt.transaction_no
                                ? char.toUpperCase(dt.transaction_no)
                                : "N/A"}
                            </td>
                            <td>
                              {dt.amount_paid
                                ? number.fNumberDoublePoint(dt.amount_paid)
                                : "0.00"}
                            </td>
                            <td>
                              {dt.balance
                                ? number.fNumberDoublePoint(dt.balance)
                                : "0.00"}
                            </td>
                          </tr>
                        ))}
                        {!data.length && (
                          <tr>
                            <td colSpan={15} className="text-center">
                              {char.toLowerCase("no data to print")}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {loading && (
            <Loader
              size="lg"
              speed="slow"
              center
              backdrop
              style={{ color: "orange" }}
              content="loading..."
              vertical
            />
          )}
        </div>
      </div>
      <Modal
        title="Enter File Name"
        open={open}
        onOk={handleExport}
        onCancel={() => setOpen(false)}
      >
        <Input
          placeholder="Enter file name"
          value={fileName}
          onChange={(e) => setFileName(e.target.value)}
        />
      </Modal>
    </>
  );
};
